import React, { useContext } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { Navbar } from "shards-react";

import NavbarSearch from "./NavbarSearch";
import NavbarNav from "./NavbarNav/NavbarNav";
import NavbarToggle from "./NavbarToggle";
import { SidebarContext } from "../../../providers/SidebarProvider";

const MainNavbar = ({ layout, stickyTop }) => {
  const classes = classNames(
    "main-navbar",
    "bg-white",
    stickyTop && "sticky-top"
  );
  const { toggleSidebar } = useContext(SidebarContext);

  return (
    <div className={classes}>
      {/* <Container className="p-0"> */}
      <Navbar type="light" className="align-items-stretch flex-md-nowrap p-0">
        <div
          style={{
            display: "flex",
            marginRight: "auto",
            justifyContent: "center",
            alignItems: "center"
          }}
        >
          <button
            style={{
              background: "none",
              border: "none",
              padding: "10px",
              zIndex: 1000
            }}
            onClick={toggleSidebar}
          >
            <i className="material-icons" style={{ fontSize: "24px" }}>
              menu
            </i>
          </button>
        </div>
        <div style={{ display: "flex", justifyContent: "flex-end" }}>
          <NavbarSearch />
          <NavbarNav />
          <NavbarToggle />
        </div>
      </Navbar>
      {/* </Container> */}
    </div>
  );
};

MainNavbar.propTypes = {
  /**
   * The layout type where the MainNavbar is used.
   */
  layout: PropTypes.string,
  /**
   * Whether the main navbar is sticky to the top, or not.
   */
  stickyTop: PropTypes.bool
};

MainNavbar.defaultProps = {
  stickyTop: true
};

export default MainNavbar;
